// extracted by mini-css-extract-plugin
export default {"banner":"FlourishClickLearningBanner_banner__5Ikue","spacer":"FlourishClickLearningBanner_spacer__50Ns8"};